import { Divider, Input, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import FreeGuidesDisplay from "./FreeGuidesDisplay";
import Icon from "../../../../assets/Icon";
import FreeGuidesIndustrySide from "./FreeGuidesIndustrySide";
import WebUtils from "../../../../utils/WebUtils";
import { getIndustriesApi } from "../../../../api/candidate";
import Utils from "../../../../utils/Utils";

const userDetail = Utils.getUserDetail();

const FreeGuidesMain = () => {
  const [guideDataFlag, setGuideDataFlag] = useState(null);
  const [clearResultsFlag, setClearResultsFlag] = useState(false);
  const [notFoundFlag, setNotFoundFlag] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchButtonText, setSearchButtonText] = useState("");
  const [jobGuideFilters, setJobGuideFilters] = useState(
    "SORT_BY_JOB"
  );
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [industryLoading, setIndustryLoading] = useState(false);
  const [industriesList, setIndustriesList] = useState([]);
  const defaultSelectedIndustryRef = useRef(false);

  const handleSortChange = (value) => {
    setJobGuideFilters(value);
  };
  const handleSearch = () => {
    setClearResultsFlag(false);
    setSearchButtonText(searchText);
  };
  const handleClearSearch = () => {
    setClearResultsFlag(true);
    setSearchText("");
    setSearchButtonText("");
  };

  const getIndustries = () => {
    const url = `${getIndustriesApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setIndustryLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setIndustryLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setIndustriesList(result.data.data);
        }
      })
      .catch((err) => {
        setIndustryLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getIndustries();
  }, []);

  useEffect(() => {
    if (industriesList?.length > 0 && !defaultSelectedIndustryRef.current) {
      setSelectedIndustry(industriesList[0]);
      defaultSelectedIndustryRef.current = true;
    }
  }, [industriesList]);

  return (
    <>
      <div className="preparation-container">
        <div className="grid gap-y-[2rem] gap-x-[1.1rem] grid-cols-12 mt-4">
          <div className="col-span-12 md:col-span-5 lg:col-span-4 2xl:col-span-3">
            <FreeGuidesIndustrySide
              industryLoading={industryLoading}
              industriesList={industriesList}
              selectedIndustry={selectedIndustry}
              setSelectedIndustry={setSelectedIndustry}
            />
          </div>

          <div className="col-span-12 md:col-span-7 lg:col-span-8 2xl:col-span-9">
            {notFoundFlag || (guideDataFlag && guideDataFlag.length > 0) ? (
              <div className="flex-1 flex flex-wrap gap-2 items-center driver-all-guide-search">
                <Input
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="w-[300px] px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
                  prefix={<Icon type="search-icon" />}
                  placeholder="Search free guides"
                  onPressEnter={handleSearch}
                />
                <div className="flex gap-2">
                  <button
                    className="w-[105px] btn-orange py-[0.35rem] px-[1rem] text-[.9rem]"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  {searchButtonText && (
                    <button
                      className="w-[135px] btn-white py-[0.35rem] px-[1rem] text-[.9rem]"
                      onClick={handleClearSearch}
                    >
                      Clear Results
                    </button>
                  )}
                </div>
                <div className="flex items-start gap-3 flex-wrap">
                  <Select
                    className="driverjs-all-guide-date-filer"
                    defaultValue="SORT_BY_JOB"
                    suffixIcon=<svg
                      width="15"
                      height="15"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                        stroke="#344054"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    style={{
                      width: 150,
                    }}
                    onChange={handleSortChange}
                    options={[
                      {
                        value: "SORT_BY_JOB",
                        label: "Sort by job",
                      },
                      {
                        value: "SORT_BY_CREATION_DATE",
                        label: "Sort by date",
                      },
                      {
                        value: "SORT_BY_COMPANY_NAME",
                        label: "Sort by company",
                      },
                      
                    ]}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            <FreeGuidesDisplay
              guideDataFlag={guideDataFlag}
              setNotFoundFlag={setNotFoundFlag}
              notFoundFlag={notFoundFlag}
              setGuideDataFlag={setGuideDataFlag}
              jobGuideFilters={jobGuideFilters}
              searchButtonText={searchButtonText}
              clearResultsFlag={clearResultsFlag}
              industriesList={industriesList}
              selectedIndustry={selectedIndustry}
              setSelectedIndustry={setSelectedIndustry}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeGuidesMain;
